import { useRecoilValue } from "recoil";
import { del, get, post, put } from "../..";
import useApiActions from "../../../recoil/api";
import { authState } from "../../../recoil/auth";

const useExamRoomActions = () => {
  const {
    getWithToken,
    postWithToken,
    delWithToken,
    putWithToken,
    postFormWithToken,
    putFormWithToken,
  } = useApiActions();

  return {
    getTotalRoomCnt,
    createExamRoom,
    fetchExamRoomList,
    sendSMS,
    sendEmail,
    sendEmailAll,
    sendMessage,
    getReceiptList,
    deleteReceipt,
    deleteTester,
    deleteRater,
    checkEmail,
    getRoomCnt,
    fetchCandidataList,
    editCandidate,
    fetchSelectedRaterList,
    fetchAllRaterList,
    addRater,
    getTestRoomInfo,
    setTestRoomInfo,
    getExercise,
    setExercise,
    getGuidance,
    setGuidance,
    assigningProblem,
    fetchSendMailList,
    fetchResultCheckList,
    fetchRaterResult,
    getExamLog,
    createUser,
    getRaterAccountList,
    deleteRaterAccount,
    getRaterAccount,
    setRaterAccountChange,
    getTts,
    setLog,
  };

  async function getTotalRoomCnt(params) {
    const res = await getWithToken("admin/totalroomCnt", params);
    return res;
  }

  async function createExamRoom(params) {
    const res = await postFormWithToken("admin/createTestRoom", params);
    return res;
  }

  /**
   *
   * @param {string} sn
   * @returns
   */

  async function sendSMS(params) {
    const res = await postWithToken("application/sendSMS", params);
    return res;
  }

  /**
   *
   * @param {string} user_sn
   * @param {string} room_sn
   * @returns
   */

  async function sendEmail(params) {
    const res = await postWithToken("admin/exmination/sendemail", params);
    return res;
  }

  async function sendEmailAll(params) {
    const res = await postWithToken("admin/exmination/sendemailAll", params);
    return res;
  }

  async function sendMessage(params) {
    // const res = await post("application/sendEmail", params);
    // return res;
  }

  /**
   *
   * @param {Object} params
   * @param {string} [params.token]
   * @param {string} params.keyword
   * @returns
   */

  async function fetchExamRoomList(params) {
    if (!params?.keyword) delete params.keyword;
    const res = getWithToken("admin/testRoomList", params);
    return res;
  }

  async function getReceiptList(params) {
    if (!params?.keyword) delete params.keyword;
    const res = await getWithToken("admin/exmination/applicator", params);
    return res;
  }

  async function deleteReceipt(params) {
    const res = delWithToken("admin/exmination/applicator", params);
    return res;
  }

  async function deleteTester(params) {
    const res = delWithToken("admin/exmination/tester", params);
    return res;
  }

  async function deleteRater(params) {
    const res = delWithToken("admin/exmination/rater", params);
    return res;
  }

  async function checkEmail(params) {
    const res = await getWithToken(
      "admin/exmination/applicator/sendCodeContent",
      params
    );
    return res;
  }

  async function getRoomCnt(params) {
    const res = await getWithToken("admin/roomCnt", params);
    return res;
  }

  async function fetchCandidataList(params) {
    const res = await getWithToken("admin/exmination/testerList", params);
    return res;
  }

  async function editCandidate(params) {
    return post("application/setApplicator", params);
  }

  async function fetchSelectedRaterList(params) {
    return getWithToken("admin/exmination/raterList", params);
  }

  async function fetchAllRaterList(params) {
    return getWithToken("admin/exmination/allRaterList", params);
  }

  async function addRater(params) {
    return postWithToken("admin/exmination/rater", params);
  }

  async function getTestRoomInfo(params) {
    return getWithToken("admin/roomInfo", params);
  }

  async function setTestRoomInfo(params) {
    return postWithToken("admin/roomInfo", params);
  }

  async function getExercise(params) {
    return getWithToken("admin/getExercise", params);
  }

  async function setExercise(params) {
    return postWithToken("admin/setExercise", params);
  }

  async function getGuidance(params) {
    return getWithToken("admin/getGuidance", params);
  }

  async function setGuidance(params) {
    return postWithToken("admin/setGuidance", params);
  }

  async function assigningProblem(params) {
    // return postWithToken("admin/exmination/assignQuestion", params);
    return postWithToken("admin/exmination/assignQuestion", params);
  }

  async function fetchSendMailList(params) {
    return getWithToken("admin/exmination/sendCodeList", params);
  }

  async function fetchResultCheckList(params) {
    return getWithToken("admin/exmination/testeResult", params);
  }

  async function fetchRaterResult(params) {
    return getWithToken("admin/exmination/testerRatingResult", params);
  }

  async function getExamLog(params) {
    return getWithToken("admin/exmination/examlog", params);
  }

  async function createUser(params) {
    return postWithToken("admin/account/rater", params);
  }

  async function getRaterAccountList(params) {
    return getWithToken("admin/account/raterList", params);
  }

  async function deleteRaterAccount(params) {
    const res = delWithToken("admin/account/rater", params);
    return res;
  }

  async function getRaterAccount(params) {
    return getWithToken("admin/account/rater", params);
  }

  async function setRaterAccountChange(params) {
    return putWithToken("admin/account/rater", params);
  }

  async function getTts(params) {
    return postWithToken("admin/question/makeAudio", params);
  }

  async function setLog(params) {
    return postWithToken("index/setLog", params);
  }
};

export default useExamRoomActions;
